export default [
  {
    path: '/app/laboratory-forms',
    name: 'LaboratoryForms',
    component: () => import('@/views/Admin/Laboratory_forms/Index.vue'),
    meta: {
      pageTitle: 'Laboratuvar',
      breadcrumb: [
        {
          text: 'Formlar',
          active: true,
        },
      ],
      resource: 'ADMIN_LAB',
      action: 'read',
    },
  },
  {
    path: '/app/laboratory-forms/add',
    name: 'LaboratoryFormAdd',
    component: () => import('@/views/Admin/Laboratory_forms/Add.vue'),
    meta: {
      pageTitle: 'Laboratuvar',
      breadcrumb: [
        {
          text: 'Formlar',
          to: '/app/laboratory-forms',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_LAB',
      action: 'read',
    },
  },
  {
    path: '/app/laboratory-forms/edit/:id',
    name: 'LaboratoryFormEdit',
    component: () => import('@/views/Admin/Laboratory_forms/Edit.vue'),
    meta: {
      pageTitle: 'Laboratuvar',
      breadcrumb: [
        {
          text: 'Formlar',
          to: '/app/laboratory-forms',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_LAB',
      action: 'read',
    },
  },
]
